import React from 'react'
import Footer from './Footer'
import FooterStrip from './FooterStrip'
import Footer_disclaimer from './Footer_disclaimer'

const Main_Footer = () => {
  return (
    <div >
      <Footer />
      <FooterStrip />
    </div>
  )
}

export default Main_Footer